import _ from 'lodash';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import FMPHeadline from '../../components/ui/FMPHeadline';

import RackTransfersContainer from '../../containers/accounting/RackTransfers';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { getDocuments } from './general';
import InvoiceDocumentIcon from '../../components/ui/invoiceDocumentIcon';
import InvoiceDocumentPopup from '../../components/Dialogs/InvoiceDocumentPopup';
import PendingIcon from '@material-ui/icons/AccessTime';
import CheckIcon from '@material-ui/icons/Check';
import InvalidIcon from '@material-ui/icons/DeleteForever';
import ViewRackTransferLogDialog from '../../components/Dialogs/ViewRackTransferLogDialog';

import { isFiltered, sortTable, PureRecordRow } from '../../libs/utility';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Typography from '@material-ui/core/Typography';
import { getSharedStyles } from '../../themes';

const invoiceStatusClassNames = {
	pending: {
		fontWeight: 900,
		color: '#2196F3',
	},
	error: {
		fontWeight: 900,
		color: '#FF500F',
	},
	sent: {
		fontWeight: 900,
		color: '#FF500F',
	},
	cancelled: {
		fontWeight: 900,
		color: '#FF500F',
	},
	invalid: {
		fontWeight: 900,
		color: '#FF500F',
	},
	pendingVeryOld: {
		fontWeight: 900,
		color: '#FF500F',
	},
	pendingOld: {
		fontWeight: 900,
		color: '#FF9800',
	},
	normal: {
		color: '#616161',
		fontWeight: 900,
	},
	complete: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	paid: {
		fontWeight: 900,
		color: '#4CAF50',
	},
};

const styles = (theme) => ({
	...getSharedStyles(theme),
	...invoiceStatusClassNames,
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	stats: {
		padding: '20px 10px 20px 10px',
		borderBottom: '1px solid #ddd',
		marginBottom: 10,
	},
	statGroup: {
		padding: '5px 5px 10px 5px',
		borderBottom: '1px solid #eee',
		marginBottom: 10,
	},
	available: {
		fontWeight: 900,
	},
	invoiceDocument: {
		position: 'absolute',
	},
	invoiceDocumentContainer: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
	},
});

//const columnStyle = { whiteSpace : 'nowrap' };
const pendingColumns = [
	{
		id: 'rackTransferId',
		label: 'Rack Transfer #',
	},
	{
		id: 'deliveryDateSort',
		label: 'Delivery Date',
	},
	{
		id: 'pickup',
		label: 'Pickup',
	},
	{
		id: 'offload',
		label: 'Offload',
	},
	{
		id: 'deliveryInfo',
		label: 'Delivery Info',
	},
	{
		id: 'documentInfo',
		label: 'Documents',
	},
	{
		id: 'status',
		label: 'Status',
	},
	{
		id: 'edit',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const invalidColumns = pendingColumns;

const completeColumns = [
	{
		id: 'rackTransferId',
		label: 'Rack Transfer #',
	},
	{
		id: 'deliveryInfo',
		label: 'Delivery Info',
	},
	{
		id: 'fuelInfo',
		label: 'Fuel Info',
	},
	{
		id: 'loadingNumber',
		label: 'Loading #',
	},
	{
		id: 'documentInfo',
		label: 'Documents',
	},
	{
		id: 'status',
		label: 'Status',
	},
	{
		id: 'edit',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const statusToDisplay = {
	pending: 'Pending',
	complete: 'Complete',
	invalid: 'Invalid',
};

// Create our number formatter.
const moneyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
	// the default value for minimumFractionDigits depends on the currency
	// and is usually already 2
});

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

class RackTransfers extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'pending');

		const startingTabIndex =
			{
				pending: 0,
				complete: 1,
				invalid: 2,
			}[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			pendingOrder: 'asc',
			pendingOrderBy: 'deliveryDateSort',
			invalidOrder: 'asc',
			invalidOrderBy: 'deliveryDateSort',
			completeOrder: 'desc',
			completeOrderBy: 'rackTransferId',
			search: '',
			filterMap: {},
			isViewDialogOpen: false,
			viewRackTransfer: undefined,
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],

			pendingRows: undefined,
			invalidRows: undefined,
			completeRows: undefined,
		};
	}

	componentDidMount() {
		const { pendingRackTransfers, completeRackTransfers, invalidRackTransfers } = this.props;
		const {
			pendingOrder,
			pendingOrderBy,
			invalidOrder,
			invalidOrderBy,
			completeOrder,
			completeOrderBy,
		} = this.state;

		const newState = {};

		if (!pendingRackTransfers) {
			this.props.searchRackTransfers({
				status: 'pending',
			});
		} else {
			const data = this.formatPendingAndInvalidRackTransfers({
				rackTransfers: this.props.pendingRackTransfers,
				statusType: 'pending',
			});
			newState.pendingRows = sortTable({ data, order: pendingOrder, orderBy: pendingOrderBy });
		}

		if (!completeRackTransfers) {
			this.props.searchRackTransfers({
				status: 'complete',
				afterDate: moment().subtract(20, 'days').format('YYYY-MM-DD'),
			});
		} else {
			const data = this.formatCompleteRackTransfers({
				rackTransfers: this.props.completeRackTransfers,
			});
			newState.completeRows = sortTable({ data, order: completeOrder, orderBy: completeOrderBy });
		}

		if (!invalidRackTransfers) {
			this.props.searchRackTransfers({
				status: 'invalid',
				afterDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
			});
		} else {
			const data = this.formatPendingAndInvalidRackTransfers({
				rackTransfers: this.props.invalidRackTransfers,
				statusType: 'invalid',
			});
			newState.invalidRows = sortTable({ data, order: invalidOrder, orderBy: invalidOrderBy });
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			pendingOrder,
			pendingOrderBy,
			invalidOrder,
			invalidOrderBy,
			completeOrder,
			completeOrderBy,
		} = this.state;

		const newState = {};

		//- Format the rows when you first get them or they change
		if (prevProps.pendingRackTransfers !== this.props.pendingRackTransfers) {
			const data = this.formatPendingAndInvalidRackTransfers({
				rackTransfers: this.props.pendingRackTransfers,
				statusType: 'pending',
			});
			newState.pendingRows = sortTable({ data, order: pendingOrder, orderBy: pendingOrderBy });
		}

		//- Format the rows when you first get them or they change
		if (prevProps.invalidRackTransfers !== this.props.invalidRackTransfers) {
			const data = this.formatPendingAndInvalidRackTransfers({
				rackTransfers: this.props.invalidRackTransfers,
				statusType: 'invalid',
			});
			newState.invalidRows = sortTable({ data, order: invalidOrder, orderBy: invalidOrderBy });
		}

		if (prevProps.completeRackTransfers !== this.props.completeRackTransfers) {
			const data = this.formatCompleteRackTransfers({
				rackTransfers: this.props.completeRackTransfers,
			});
			newState.completeRows = sortTable({ data, order: completeOrder, orderBy: completeOrderBy });
		}

		//- Sort
		if (prevState.pendingOrder !== pendingOrder || prevState.pendingOrderBy !== pendingOrderBy) {
			newState.pendingRows = sortTable({
				data: this.state.pendingRows,
				order: pendingOrder,
				orderBy: pendingOrderBy,
			});
		}

		if (prevState.invalidOrder !== invalidOrder || prevState.invalidOrderBy !== invalidOrderBy) {
			newState.invalidRows = sortTable({
				data: this.state.invalidRows,
				order: invalidOrder,
				orderBy: invalidOrderBy,
			});
		}

		if (
			prevState.completeOrder !== completeOrder ||
			prevState.completeOrderBy !== completeOrderBy
		) {
			newState.completeRows = sortTable({
				data: this.state.completeRows,
				order: completeOrder,
				orderBy: completeOrderBy,
			});
		}

		//- Type to search needs to filter
		if (prevState.search !== this.state.search) {
			newState.filterMap = this.getFilterMap();
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	getDocumentInfo = (uploadedInvoiceDocuments) => {
		const { classes, resourceMap } = this.props;

		if (_.isEmpty(uploadedInvoiceDocuments)) {
			return 'None yet';
		}

		//- Documents
		let left = 0;
		let zIndex = 100;
		return (
			<div
				className={classes.invoiceDocumentContainer}
				onClick={() => {
					this.onDocumentClick(uploadedInvoiceDocuments);
				}}
			>
				{uploadedInvoiceDocuments.map((invoiceDocument, i) => {
					left = i * 10;
					zIndex--;
					return (
						<div className={classes.invoiceDocument} style={{ left, zIndex }} key={i}>
							<InvoiceDocumentIcon
								hasTooltip={false}
								invoiceDocument={invoiceDocument}
								resourceMap={resourceMap}
								onClick={_.noop}
							/>
						</div>
					);
				})}
			</div>
		);
	};

	formatPendingAndInvalidRackTransfers = ({ rackTransfers, statusType }) => {
		const ret = [];
		const {
			bulkDeliveryMap,
			bulkCustomerMap,
			carrierMap,
			invoiceDocumentMap,
			terminalMap,
			//resourceMap,
			supplierMap,
		} = this.props;

		rackTransfers.forEach((rackTransfer) => {
			const { rackTransferId, linkedBulkDeliveryId, invoiceDocumentIds } = rackTransfer;
			let status = rackTransfer.status;

			//- Delivery
			const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];

			if (!bulkDelivery) {
				ret.push({
					rackTransferId,
					pickup: `Missing linked bulk delivery ${linkedBulkDeliveryId}`,
				});
				return ret;
			}

			//- Bulk Delivery Information
			const {
				deliveryTerminalId,
				deliveryBulkCustomerId,
				pickupTerminalId,
				pickupSupplierId,
				deliveryDate,
				carrierId,
			} = bulkDelivery;

			const pickupTerminal = terminalMap[pickupTerminalId];
			const pickupTerminalDisplay = pickupTerminal ? pickupTerminal.name : 'Missing Terminal';

			const pickupSupplier = supplierMap[pickupSupplierId];
			const pickupSupplierDisplay = pickupSupplier ? pickupSupplier.name : 'Missing Supplier';

			const pickupDisplay = (
				<div>
					<div>{pickupTerminalDisplay}</div>
					<div>{pickupSupplierDisplay}</div>
				</div>
			);

			const deliveryTerminal = terminalMap[deliveryTerminalId];
			const deliveryTerminalDisplay = deliveryTerminal ? deliveryTerminal.name : 'Missing Terminal';

			const deliveryBulkCustomer = bulkCustomerMap[deliveryBulkCustomerId];
			const deliveryBulkCustomerDisplay = deliveryBulkCustomer
				? deliveryBulkCustomer.name
				: 'Missing Bulk Customer';

			const offloadDisplay = (
				<div>
					<div>{deliveryTerminalDisplay}</div>
					<div>{deliveryBulkCustomerDisplay}</div>
				</div>
			);

			const carrier = carrierMap[carrierId];
			const carrierDisplay = carrier ? carrier.name : 'Missing Carrier';

			const deliveryDisplay = (
				<div>
					<div>Delivery #{linkedBulkDeliveryId}</div>
					<div>{carrierDisplay}</div>
				</div>
			);

			let deliveryMoment = moment(deliveryDate);
			let deliveryDateSort = deliveryMoment.format('YYYY-MM-DD');
			let deliveryDateDisplay = deliveryMoment.format('ddd, M/D');

			//- Rack Transfer
			const invoiceDocuments = invoiceDocumentIds.map((invoiceDocumentId) => {
				return invoiceDocumentMap[invoiceDocumentId] || { name: 'MISSING' };
			});

			const { uploadedInvoiceDocuments } = getDocuments({
				stationDelivery: bulkDelivery,
				carrierMap,
				terminalMap,
				supplierMap,
				invoiceDocuments,
			});
			let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);

			//- Status
			const fourDaysAgo = moment().subtract(4, 'days');
			const sixDaysAgo = moment().subtract(6, 'days');
			if (status === 'pending' && deliveryMoment.isBefore(sixDaysAgo)) {
				status = 'pendingVeryOld';
			} else if (status === 'pending' && deliveryMoment.isBefore(fourDaysAgo)) {
				status = 'pendingOld';
			}

			const statusDisplay =
				{
					pending: 'Pending',
					complete: 'Complete',
					pendingOld: (
						<Fragment>
							<div>Pending</div>
							<div>(4+ days old)</div>
						</Fragment>
					),
					pendingVeryOld: (
						<Fragment>
							<div>Pending!</div>
							<div>(6+ days old)</div>
						</Fragment>
					),
				}[status] || status;

			ret.push({
				rackTransferId,

				deliveryDateDisplay,
				deliveryDateSort,

				pickupDisplay,
				offloadDisplay,
				deliveryDisplay,

				documentInfo,
				status,
				statusDisplay,
				rowClick: () => {
					this.handleRowClick(rackTransferId, statusType);
				},
			});
		});
		return ret;
	};

	formatCompleteRackTransfers = ({ rackTransfers }) => {
		return rackTransfers.map((rackTransfer) => {
			const {
				bulkCustomerMap,
				carrierMap,
				invoiceDocumentMap,
				bulkDeliveryMap,
				terminalMap,
				//resourceMap,
				supplierMap,
			} = this.props;

			const {
				rackTransferId,
				linkedBulkDeliveryId,
				bulkCustomerId,
				carrierId,
				status,
				invoiceDocumentIds,
				loadingNumber,
			} = rackTransfer;

			const bulkCustomer = bulkCustomerMap[bulkCustomerId] || {
				number: '',
				name: 'Missing bulk customer',
			};
			const bulkCustomerDisplay = `${bulkCustomer.name}`;

			//- Delivery
			const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];
			let deliveryInfo = <span>Delivery {linkedBulkDeliveryId} not found</span>;
			if (bulkDelivery) {
				const { deliveryDate, bulkDeliveryId } = bulkDelivery;

				const dateDisplay = moment(deliveryDate).format('ddd, M/D');
				deliveryInfo = (
					<Fragment>
						<div>{bulkCustomerDisplay}</div>
						<div>Delivery #{bulkDeliveryId}</div>
						<div>{dateDisplay}</div>
					</Fragment>
				);
			}

			//- Rack Transfer
			const invoiceDocuments = invoiceDocumentIds.map((invoiceDocumentId) => {
				return invoiceDocumentMap[invoiceDocumentId] || { name: 'MISSING' };
			});

			const { uploadedInvoiceDocuments, missingInvoiceDocuments } = getDocuments({
				bulkDelivery,
				carrierMap,
				terminalMap,
				supplierMap,
				invoiceDocuments,
				isRackTransfer: true,
			});

			let fuelInfo = null;
			const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };
			if (!_.isEmpty(_.filter(missingInvoiceDocuments, { isRequired: true }))) {
				fuelInfo = (
					<Fragment>
						<div>{carrier.name}</div>
						<div>No documents yet.</div>
					</Fragment>
				);
			} else {
				const {
					pickupTerminalId,
					offloadTerminalId,
					pickupNetGallons,
					offloadNetGallons,
				} = rackTransfer;

				const pickupTerminal = terminalMap[pickupTerminalId] || {
					name: `Missing terminal : ${pickupTerminalId}`,
				};

				const offloadTerminal = terminalMap[offloadTerminalId] || {
					name: `Missing terminal : ${offloadTerminalId}`,
				};

				fuelInfo = (
					<Fragment>
						<div>{carrier.name}</div>
						<div>
							Pickup : {pickupNetGallons} from {pickupTerminal.name}
						</div>
						<div>
							Offload : {offloadNetGallons} to {offloadTerminal.name}
						</div>
					</Fragment>
				);
			}

			//- Documents
			let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);
			const statusDisplay = statusToDisplay[status] || status;

			let invoiceTotal = <span>{moneyFormatter.format(rackTransfer.total)}</span>;
			return {
				rackTransferId,
				deliveryInfo,
				invoiceTotal,
				fuelInfo,
				loadingNumber,
				documentInfo,
				linkedBulkDeliveryId,
				bulkCustomerId,
				carrierId,
				status,
				statusDisplay,
				rowClick: () => {
					this.handleRowClick(rackTransferId, 'complete');
				},
			};
		});
	};

	getFilterMap = () => {
		const { search, pendingRows, invalidRows, completeRows } = this.state;
		const filterMap = {};
		pendingRows.concat(completeRows, invalidRows).forEach((row) => {
			if (
				isFiltered({
					search,
					data: row,
					fields: ['rackTransferId', 'bulkCustomerDisplay', 'deliveryId'],
				})
			) {
				filterMap[row.rackTransferId] = true;
			}
		});
		return filterMap;
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handlePendingSort = (orderBy) => {
		let order = 'desc';
		if (this.state.pendingOrderBy === orderBy && this.state.pendingOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ pendingOrder: order, pendingOrderBy: orderBy });
	};

	handleInvalidSort = (orderBy) => {
		let order = 'desc';
		if (this.state.invalidOrderBy === orderBy && this.state.invalidOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ invalidOrder: order, invalidOrderBy: orderBy });
	};

	handleCompleteSort = (orderBy) => {
		let order = 'desc';
		if (this.state.completeOrderBy === orderBy && this.state.completeOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ completeOrder: order, completeOrderBy: orderBy });
	};

	handleEdit = (rackTransferId) => {
		this.props.history.push(`/accounting/rackTransfer/update/${rackTransferId}`);
	};

	handleRowClick = (rackTransferId, type) => {
		let viewRackTransfer;

		if (type === 'pending') {
			const { pendingRackTransfers } = this.props;
			viewRackTransfer = _.find(pendingRackTransfers, { rackTransferId });
		} else if (type === 'invalid') {
			const { invalidRackTransfers } = this.props;
			viewRackTransfer = _.find(invalidRackTransfers, { rackTransferId });
		} else if (type === 'complete') {
			const { completeRackTransfers } = this.props;
			viewRackTransfer = _.find(completeRackTransfers, { rackTransferId });
		}
		this.setState({
			viewRackTransfer,
			isViewDialogOpen: true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewRackTransfer: undefined,
		});
	};

	handleCloseInvoiceDocumentPopup = () => {
		this.setState({
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
		});
	};

	onDocumentClick = (invoiceDocuments) => {
		this.setState({
			isInvoiceDocumentPopupOpen: true,
			invoiceDocumentsPoppedUp: invoiceDocuments,
		});
	};

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	render() {
		const { classes, canMakeUpdates, resourceMap, theme } = this.props;

		const {
			pendingRows,
			completeRows,
			invalidRows = [],
			pendingOrder,
			pendingOrderBy,
			invalidOrder,
			invalidOrderBy,
			completeOrder,
			completeOrderBy,
			filterMap,
		} = this.state;

		if (!pendingRows || !completeRows) {
			return <div>Loading the Rack Transfers...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Rack Transfers"
						value={this.state.search}
						onChange={this.handleSearch}
						canMakeUpdates={canMakeUpdates}
					/>

					<AppBar position="static" color="default">
						<Tabs
							value={this.state.tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab label="All Pending" icon={<PendingIcon />} />
							<Tab label="Recently Completed" icon={<CheckIcon />} />
							<Tab label="Recently Invalid" icon={<InvalidIcon />} />
						</Tabs>
					</AppBar>
					<Paper className={classes.paper}>
						<SwipeableViews
							axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
							index={this.state.tabIndex}
							onChangeIndex={this.handleChangeTabIndex}
						>
							<TabContainer dir={theme.direction}>
								<Table size="small" className={classes.table}>
									<EnhancedTableHead
										columnData={pendingColumns}
										order={pendingOrder}
										orderBy={pendingOrderBy}
										onRequestSort={this.handlePendingSort}
									/>
									<TableBody>
										{pendingRows.map((row) => {
											if (filterMap[row.rackTransferId]) {
												return null;
											}

											return (
												<PureRecordRow hover className={classes.row} key={row.rackTransferId}>
													<TableCell onClick={row.rowClick}>{row.rackTransferId}</TableCell>
													<TableCell onClick={row.rowClick}>{row.deliveryDateDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.pickupDisplay}</TableCell>

													<TableCell onClick={row.rowClick}>{row.offloadDisplay}</TableCell>

													<TableCell onClick={row.rowClick}>{row.deliveryDisplay}</TableCell>

													<TableCell>{row.documentInfo}</TableCell>

													<TableCell
														onClick={row.rowClick}
														className={classes[row.status]}
														style={{ whiteSpace: 'nowrap' }}
													>
														{row.statusDisplay}
													</TableCell>

													{canMakeUpdates && (
														<TableCell style={{ whiteSpace: 'nowrap' }}>
															<Button
																className={classes.button}
																onClick={() => this.handleEdit(row.rackTransferId)}
															>
																Edit
															</Button>
														</TableCell>
													)}
												</PureRecordRow>
											);
										})}
									</TableBody>
								</Table>
							</TabContainer>
							<TabContainer dir={theme.direction}>
								<Table size="small" className={classes.table}>
									<EnhancedTableHead
										columnData={completeColumns}
										order={completeOrder}
										orderBy={completeOrderBy}
										onRequestSort={this.handleCompleteSort}
									/>
									<TableBody>
										{completeRows.map((row) => {
											if (filterMap[row.rackTransferId]) {
												return null;
											}
											return (
												<PureRecordRow hover className={classes.row} key={row.rackTransferId}>
													<TableCell onClick={row.rowClick}>{row.rackTransferId}</TableCell>
													<TableCell onClick={row.rowClick}>{row.deliveryInfo}</TableCell>
													<TableCell onClick={row.rowClick}>{row.fuelInfo}</TableCell>
													<TableCell onClick={row.rowClick}>{row.loadingNumber}</TableCell>
													<TableCell>{row.documentInfo}</TableCell>
													<TableCell
														onClick={row.rowClick}
														className={classes[row.status]}
														style={{ whiteSpace: 'nowrap' }}
													>
														{row.statusDisplay}
													</TableCell>

													{canMakeUpdates && (
														<TableCell style={{ whiteSpace: 'nowrap' }}>
															<Button
																className={classes.button}
																onClick={() => this.handleEdit(row.rackTransferId)}
															>
																Edit
															</Button>
														</TableCell>
													)}
												</PureRecordRow>
											);
										})}
									</TableBody>
								</Table>
							</TabContainer>

							<TabContainer dir={theme.direction}>
								<Table size="small" className={classes.table}>
									<EnhancedTableHead
										columnData={invalidColumns}
										order={invalidOrder}
										orderBy={invalidOrderBy}
										onRequestSort={this.handleInvalidSort}
									/>
									<TableBody>
										{invalidRows.map((row) => {
											if (filterMap[row.rackTransferId]) {
												return null;
											}

											return (
												<PureRecordRow hover className={classes.row} key={row.rackTransferId}>
													<TableCell onClick={row.rowClick}>{row.rackTransferId}</TableCell>
													<TableCell onClick={row.rowClick}>{row.deliveryDateDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.pickupDisplay}</TableCell>

													<TableCell onClick={row.rowClick}>{row.offloadDisplay}</TableCell>

													<TableCell onClick={row.rowClick}>{row.deliveryDisplay}</TableCell>

													<TableCell onClick={row.rowClick}>{row.documentInfo}</TableCell>

													<TableCell
														onClick={row.rowClick}
														className={classes[row.status]}
														style={{ whiteSpace: 'nowrap' }}
													>
														{row.statusDisplay}
													</TableCell>

													{canMakeUpdates && (
														<TableCell style={{ whiteSpace: 'nowrap' }}>
															<Button
																className={classes.button}
																onClick={() => this.handleEdit(row.rackTransferId)}
															>
																Edit
															</Button>
														</TableCell>
													)}
												</PureRecordRow>
											);
										})}
									</TableBody>
								</Table>
							</TabContainer>
						</SwipeableViews>

						<InvoiceDocumentPopup
							open={this.state.isInvoiceDocumentPopupOpen}
							onClose={this.handleCloseInvoiceDocumentPopup}
							invoiceDocuments={this.state.invoiceDocumentsPoppedUp}
							resourceMap={resourceMap}
						/>

						<ViewRackTransferLogDialog
							open={this.state.isViewDialogOpen}
							onClose={this.handleCloseViewDialog}
							rackTransfer={this.state.viewRackTransfer}
							history={this.props.history}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

RackTransfers.propTypes = {
	classes: PropTypes.object.isRequired,
	searchRackTransfers: PropTypes.func.isRequired,
	//rackTransfers : PropTypes.array,
	pendingRackTransfers: PropTypes.array,
	invalidRackTransfers: PropTypes.array,
	completeRackTransfers: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	bulkCustomerMap: PropTypes.object,
	supplierMap: PropTypes.object,
	carrierMap: PropTypes.object,
	terminalMap: PropTypes.object,
	resourceMap: PropTypes.object,
	invoiceDocumentMap: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	canMakeUpdates: PropTypes.bool,
};

export default _.flow([withStyles(styles, { withTheme: true }), RackTransfersContainer])(
	RackTransfers
);
